// @flow

import type { TasksState } from "./types";

export const initialState: TasksState = {
  error: null,
  requestsInProgress: 0,
  modals: {
    showLateSubmissionModal: false,
  },
  schemas: {
    absenceTask: null,
  },
  search: {
    employee: "",
    type: null,
  },
  myTasks: {
    selectedTask: null,
    selectedTaskHistory: null,
    overdueCount: 0,
    rtwInterviewTasksCount: 0,
    referralDecisionTaskCount: 0,
    absenceMonitoringReviewTaskCount: 0,
    totalTasksCount: 0,
    list: {
      content: [],
      pagination: {
        pageNumber: 1,
        pageSize: 50,
        sort: {
          orders: [],
        },
        offset: 0,
      },
      totalElements: 0,
    },
  },
  tasksPerformance: {
    taskCompleted: 0,
    completedOnTime: 0,
    compliancePercentage: 0,
  },
};

export default initialState;
